'use client';

import { Menu } from '@headlessui/react';
import { cx } from 'cva';
import React, { useState, useRef, useEffect } from 'react';
import Typography from '@/components/next-ui/Typography';
import { useHomeFeedFilters } from '@/actions/feed.actions';

function ChipFilter({ value, label, parentLabel, onToggle, reset }) {
  const setPostTypeFilters = useHomeFeedFilters(
    (state) => state.setPostTypeFilters,
  );

  const [isSelected, setIsSelected] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    const toggleSelection = !isSelected ? { label, value } : null;

    let otherFilters = {};

    if (toggleSelection) {
      switch (label) {
        case 'Volunteer':
          otherFilters = { ...otherFilters, [parentLabel]: true };
          setPostTypeFilters({ volunteer: otherFilters });
          break;
        case 'Nonprofit News':
          otherFilters = { ...otherFilters, [parentLabel]: true };
          setPostTypeFilters({ others: otherFilters, nonProfitNews: true });
          break;
        default:
          break;
      }
      onToggle(toggleSelection);
    }

    setIsSelected((prev) => !prev);
  };

  const handleReset = () => {
    setIsSelected(false);
  };

  useEffect(() => {
    if (reset) {
      handleReset();
    }
  }, [reset]);

  return (
    <Menu
      as="div"
      className="relative inline-block cursor-pointer text-left"
      ref={menuRef}>
      <div>
        <Menu.Button
          onClick={toggleMenu}
          className={cx(
            'inline-flex w-full justify-center rounded-lg px-6 py-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75',
            isSelected ? 'bg-chips-primary ' : 'bg-primary-light-1 ',
          )}>
          <Typography variant="body1" color="textPrimary">
            {label}
          </Typography>
        </Menu.Button>
      </div>
    </Menu>
  );
}

export default React.memo(ChipFilter);
